import { render, staticRenderFns } from "./lift.vue?vue&type=template&id=76732f20&scoped=true"
var script = {}
import style0 from "./lift.vue?vue&type=style&index=0&id=76732f20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76732f20",
  null
  
)

export default component.exports